import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { TeamworkGraphShareContextButton } from './visualization/TeamworkGraphShareContextButton.tsx';

const styles = cssMap({
	footer: {
		flexShrink: 0,
		boxSizing: 'border-box',
		display: 'flex',
		alignItems: 'center',
		paddingBlock: token('space.200'),
		paddingInline: token('space.300'),
		borderTopStyle: 'solid',
		borderTopWidth: token('border.width'),
		borderTopColor: token('color.border'),
		backgroundColor: token('elevation.surface'),
	},
});

export function TeamworkGraphPreviewPanelFooter({
	contentId,
	testId,
	onAskRovo,
}: {
	contentId?: string;
	testId?: string;
	/** Forwarded to the share-context modal's Rovo button; see `ShareContextModalProps`. */
	onAskRovo?: (prompt: string) => void;
}): React.JSX.Element {
	return (
		<Box as="footer" testId={testId} xcss={styles.footer}>
			<TeamworkGraphShareContextButton
				contentId={contentId}
				testId={testId && `${testId}-share-context`}
				variant="footer"
				shouldFitContainer
				onAskRovo={onAskRovo}
			/>
		</Box>
	);
}
